import { render, staticRenderFns } from "./receivable-modal.vue?vue&type=template&id=efdbde70&"
import script from "./receivable-modal.vue?vue&type=script&lang=js&"
export * from "./receivable-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports